// Edits the existing question control so dirty tracking, validation and lossless
// persistence remain owned by the normal flow editor.
export function mountCanvasEditor(root, { getSelection, getControl, isLocked = () => false }) {
  const panel = document.createElement('section');
  panel.className = 'mag-canvas-editor'; panel.hidden = true;
  panel.setAttribute('aria-label', 'Edit question wording');
  panel.innerHTML = '<header><strong data-canvas-title></strong><button type="button" data-canvas-done>Done</button></header><label for="mag-canvas-wording">Question wording</label><textarea id="mag-canvas-wording" rows="3" aria-describedby="mag-canvas-help"></textarea><p id="mag-canvas-help">Updates the selected question as you type. Changes are unsaved until you save.</p>';
  root.append(panel);
  const input = panel.querySelector('textarea');
  let selectedKey = '', returnFocus = null;
  const key = value => value ? `${value.route}:${value.uid}` : '';
  const close = (restoreFocus = false) => {
    const wasOpen = !panel.hidden; panel.hidden = true; selectedKey = '';
    if (restoreFocus && wasOpen && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  };
  const sync = () => {
    if (panel.hidden) return;
    const selection = getSelection(), control = getControl();
    if (!control || key(selection) !== selectedKey) { close(); return; }
    panel.querySelector('[data-canvas-title]').textContent = `Question ${selection.index + 1} of ${selection.total}`;
    if (input.value !== control.value) input.value = control.value;
  };
  input.addEventListener('input', () => {
    if (isLocked()) { sync(); return; }
    const control = getControl();
    if (!control || key(getSelection()) !== selectedKey) { close(); return; }
    control.value = input.value;
    control.dispatchEvent(new Event('input', { bubbles: true }));
  });
  panel.querySelector('[data-canvas-done]').addEventListener('click', () => close(true));
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(true); }
  });
  return {
    open() {
      const selected = getSelection(), control = getControl();
      if (!selected || !control || isLocked()) return;
      returnFocus = document.activeElement; selectedKey = key(selected);
      panel.hidden = false; sync(); input.focus({ preventScroll: true });
    },
    sync, close,
    destroy() { panel.remove(); },
  };
}
